module.exports = __webpack_public_path__ + "assets/img/7e3ed6b769195bcb801d6b5d5e756079.svg";